export const stats = {
  totalStudents: 241,
  totalCourses: 6,
  activeExams: 2,
  totalExams: 8,
};

export const courses = [
  { id: 'SC101', name: 'ทฤษฎีการสื่อสารมวลชน', teacher: 'รศ.ดร.สมชาย วงศ์ประภา', students: 45, year: '2567', semester: 1, status: 'เปิดสอน' },
  { id: 'SC102', name: 'สื่อดิจิทัลเบื้องต้น', teacher: 'ผศ.ดร.นิภาพรรณ สุขสมบัติ', students: 52, year: '2567', semester: 1, status: 'เปิดสอน' },
  { id: 'SC201', name: 'การผลิตสื่อวิดีโอ', teacher: 'อ.ดร.กรณ์ อภิวัฒน์', students: 38, year: '2567', semester: 1, status: 'เปิดสอน' },
  { id: 'SC202', name: 'การตลาดดิจิทัล', teacher: 'ผศ.ปณิตา เมธาวี', students: 41, year: '2567', semester: 1, status: 'เปิดสอน' },
  { id: 'SC301', name: 'จริยธรรมสื่อสารมวลชน', teacher: 'รศ.ดร.สมชาย วงศ์ประภา', students: 35, year: '2567', semester: 1, status: 'เปิดสอน' },
  { id: 'SC302', name: 'การออกแบบกราฟิกสำหรับสื่อ', teacher: 'ผศ.ดร.นิภาพรรณ สุขสมบัติ', students: 30, year: '2567', semester: 1, status: 'เปิดสอน' },
];

export const teachers = [
  // DEMO ONLY — credentials for prototype testing, never use real passwords in source code
  { id: 1, name: 'รศ.ดร.สมชาย วงศ์ประภา', courses: 2, email: 'somchai@swu.ac.th', status: 'ใช้งาน', username: 'somchai', password: 'teacher1234' },
  { id: 2, name: 'ผศ.ดร.นิภาพรรณ สุขสมบัติ', courses: 2, email: 'nipapan@swu.ac.th', status: 'ใช้งาน', username: 'nipapan', password: 'teacher1234' },
  { id: 3, name: 'อ.ดร.กรณ์ อภิวัฒน์', courses: 1, email: 'korn@swu.ac.th', status: 'ใช้งาน', username: 'korn', password: 'teacher1234' },
  { id: 4, name: 'ผศ.ปณิตา เมธาวี', courses: 1, email: 'panita@swu.ac.th', status: 'ใช้งาน', username: 'panita', password: 'teacher1234' },
];

export const activeExamsList = [
  { id: 'EX001', title: 'สอบกลางภาค: ทฤษฎีการสื่อสารมวลชน', course: 'SC101', startTime: '09:00', endTime: '11:00', submitted: 5, total: 45, status: 'กำลังสอบ' },
  { id: 'EX002', title: 'สอบกลางภาค: สื่อดิจิทัลเบื้องต้น', course: 'SC102', startTime: '13:00', endTime: '15:00', submitted: 0, total: 52, status: 'รอเริ่ม' },
];

export const mockExam = {
  id: 'EXAM001',
  title: 'สอบกลางภาค: ทฤษฎีการสื่อสารมวลชน',
  course: 'SC101 - ทฤษฎีการสื่อสารมวลชน',
  teacher: 'รศ.ดร.สมชาย วงศ์ประภา',
  duration: 60,
  totalScore: 30,
  isOpen: true,
  shuffleQuestions: false,
  shuffleOptions: false,
  questions: [
    {
      id: 1,
      type: 'ปรนัย',
      text: 'ใครเป็นผู้พัฒนาทฤษฎี "Two-Step Flow of Communication"?',
      score: 3,
      options: [
        { id: 'a', text: 'Harold Lasswell' },
        { id: 'b', text: 'Paul Lazarsfeld และ Elihu Katz', isCorrect: true },
        { id: 'c', text: 'Marshall McLuhan' },
        { id: 'd', text: 'Walter Lippmann' },
      ],
    },
    {
      id: 2,
      type: 'ปรนัย',
      text: 'สูตร "Who Says What In Which Channel To Whom With What Effect" เป็นของนักวิชาการท่านใด?',
      score: 3,
      options: [
        { id: 'a', text: 'Wilbur Schramm' },
        { id: 'b', text: 'Marshall McLuhan' },
        { id: 'c', text: 'Harold Lasswell', isCorrect: true },
        { id: 'd', text: 'Claude Shannon' },
      ],
    },
    {
      id: 3,
      type: 'ปรนัย',
      text: 'แนวคิด "The Medium is the Message" เป็นของนักทฤษฎีคนใด?',
      score: 3,
      options: [
        { id: 'a', text: 'Marshall McLuhan', isCorrect: true },
        { id: 'b', text: 'Noam Chomsky' },
        { id: 'c', text: 'Stuart Hall' },
        { id: 'd', text: 'Jürgen Habermas' },
      ],
    },
    {
      id: 4,
      type: 'ปรนัย',
      text: 'ทฤษฎี "Agenda Setting" หมายถึงสิ่งใด?',
      score: 3,
      options: [
        { id: 'a', text: 'สื่อกำหนดว่าประชาชนควรคิดอะไร' },
        { id: 'b', text: 'สื่อกำหนดว่าประชาชนควรคิดเรื่องอะไร', isCorrect: true },
        { id: 'c', text: 'สื่อโน้มน้าวประชาชนให้ซื้อสินค้า' },
        { id: 'd', text: 'สื่อสร้างภาพลักษณ์ให้กับบุคคล' },
      ],
    },
    {
      id: 5,
      type: 'ปรนัย',
      text: 'ข้อใดคือลักษณะเด่นของ "New Media" ที่แตกต่างจาก "Traditional Media"?',
      score: 3,
      options: [
        { id: 'a', text: 'มีเนื้อหาที่หลากหลายกว่า' },
        { id: 'b', text: 'มีผู้รับสารมากกว่า' },
        { id: 'c', text: 'มีการสื่อสารแบบ Interactive และ Personalized', isCorrect: true },
        { id: 'd', text: 'มีความน่าเชื่อถือสูงกว่า' },
      ],
    },
    {
      id: 6,
      type: 'อัตนัย',
      text: 'จงอธิบายความแตกต่างระหว่างทฤษฎี "One-Step Flow" และ "Two-Step Flow" พร้อมยกตัวอย่างในบริบทของสื่อสังคมออนไลน์ในปัจจุบัน (อย่างน้อย 5 บรรทัด)',
      score: 5,
      options: [],
    },
    {
      id: 7,
      type: 'อัตนัย',
      text: 'วิเคราะห์ผลกระทบของ "Fake News" ต่อระบบประชาธิปไตย โดยอ้างอิงทฤษฎีการสื่อสารมวลชนที่ได้ศึกษามา (อย่างน้อย 5 บรรทัด)',
      score: 5,
      options: [],
    },
    {
      id: 8,
      type: 'อัตนัย',
      text: 'อธิบายบทบาทที่เปลี่ยนแปลงไปของ "ผู้รับสาร" (Audience) ในยุคสื่อดิจิทัล เปรียบเทียบกับยุคสื่อดั้งเดิม (อย่างน้อย 5 บรรทัด)',
      score: 5,
      options: [],
    },
  ],
};

export const mockSubmissions = [
  {
    id: 1, studentId: '64010001', name: 'นายอภิชาติ สุรชัย', year: 2, submittedAt: '09:45:12',
    mcScore: 15, essayScores: { 5: 4, 6: 4, 7: 4 }, totalScore: 27, maxScore: 30, status: 'ตรวจแล้ว',
    answers: {
      0: 'b', 1: 'c', 2: 'a', 3: 'b', 4: 'c',
      5: 'ทฤษฎี One-Step Flow เชื่อว่าสื่อมวลชนส่งผลโดยตรงต่อผู้รับสาร โดยไม่ผ่านตัวกลางใด ในขณะที่ทฤษฎี Two-Step Flow ของ Lazarsfeld และ Katz เสนอว่าข้อมูลจะผ่าน "ผู้นำทางความคิด" (Opinion Leader) ก่อน แล้วค่อยส่งต่อไปยังประชาชนทั่วไป ตัวอย่างในสื่อสังคมออนไลน์ เช่น Influencer บน TikTok ที่รีวิวสินค้า ถือเป็นผู้นำทางความคิดยุคใหม่ที่ส่งอิทธิพลต่อผู้ติดตาม',
      6: 'Fake News ส่งผลกระทบเชิงลบต่อระบบประชาธิปไตยอย่างร้ายแรง โดยทำให้ประชาชนได้รับข้อมูลที่บิดเบือน ส่งผลต่อการตัดสินใจลงคะแนนเสียง อ้างอิงทฤษฎี Agenda Setting ของ McCombs สื่อมีบทบาทในการกำหนดวาระสาธารณะ เมื่อ Fake News เข้าสู่กระบวนการนี้จะยิ่งสร้างความเสียหายต่อการรับรู้ของสังคม',
      7: 'ผู้รับสารในยุคดิจิทัลเปลี่ยนจาก Passive Audience มาเป็น Active Prosumer ที่สามารถผลิตและเผยแพร่เนื้อหาได้เอง ต่างจากยุคสื่อดั้งเดิมอย่างสิ้นเชิง เนื่องจากในยุคสื่อดั้งเดิมผู้รับสารมีอิทธิพลน้อยมากในการสร้างเนื้อหา แต่ปัจจุบันทุกคนสามารถเป็นผู้ส่งสารได้พร้อมกัน',
    }
  },
  {
    id: 2, studentId: '64010002', name: 'นางสาวพิมพ์ใจ ทองดี', year: 2, submittedAt: '10:02:33',
    mcScore: 12, essayScores: {}, totalScore: null, maxScore: 30, status: 'รอตรวจ',
    answers: {
      0: 'b', 1: 'c', 2: 'a', 3: 'a', 4: 'c',
      5: 'One-Step Flow คือการส่งข้อมูลจากสื่อไปยังผู้รับโดยตรง ส่วน Two-Step Flow มีผู้นำความคิดเป็นตัวกลาง ในยุค Social Media เช่น Twitter ผู้ติดตามจะได้รับข้อมูลผ่าน Influencer ก่อนเสมอ',
      6: 'Fake News ทำให้ประชาชนสับสนและไม่รู้ว่าข้อมูลใดถูกต้อง ส่งผลให้ประชาธิปไตยอ่อนแอลงเพราะการตัดสินใจทางการเมืองขาดข้อมูลที่ถูกต้อง',
      7: 'ผู้รับสารในยุคดิจิทัลมีความสามารถในการโต้ตอบและสร้างเนื้อหาได้เอง ต่างจากยุคสื่อดั้งเดิมที่รับข้อมูลฝ่ายเดียว',
    }
  },
  {
    id: 3, studentId: '64010003', name: 'นายวรพล เจริญวงศ์', year: 2, submittedAt: '09:58:07',
    mcScore: 9, essayScores: {}, totalScore: null, maxScore: 30, status: 'รอตรวจ',
    answers: {
      0: 'b', 1: 'c', 2: 'c', 3: 'a', 4: 'c',
      5: 'One-Step Flow เป็นการสื่อสารตรง Two-Step Flow มีตัวกลาง',
      6: 'Fake News ส่งผลเสียต่อสังคมและประชาธิปไตย ทำให้คนเชื่อข้อมูลผิด',
      7: 'ผู้รับสารยุคใหม่สามารถสร้างเนื้อหาได้เอง',
    }
  },
  {
    id: 4, studentId: '65010001', name: 'นางสาวสุดารัตน์ มีสุข', year: 1, submittedAt: '10:15:44',
    mcScore: 15, essayScores: { 5: 5, 6: 5, 7: 4 }, totalScore: 29, maxScore: 30, status: 'ตรวจแล้ว',
    answers: {
      0: 'b', 1: 'c', 2: 'a', 3: 'b', 4: 'c',
      5: 'ทฤษฎี One-Step Flow (Hypodermic Needle Theory) เชื่อว่าสื่อมวลชนฉีดข้อมูลเข้าสู่ผู้รับสารโดยตรง ส่วน Two-Step Flow ของ Lazarsfeld พิสูจน์ว่าไม่เป็นเช่นนั้น โดยพบว่าผู้นำทางความคิดมีบทบาทสำคัญในการกรองและส่งต่อข้อมูล ตัวอย่างชัดเจนคือ YouTuber ที่รีวิวสินค้าแล้วผู้ชมนำไปบอกต่อในกลุ่มเพื่อน',
      6: 'Fake News บ่อนทำลายหลักการประชาธิปไตยที่ต้องการข้อมูลที่ถูกต้องในการตัดสินใจ โดยอ้างอิง Agenda Setting ของ McCombs และ Shaw เมื่อสื่อนำเสนอข้อมูลเท็จซ้ำๆ ประชาชนจะเชื่อว่าเรื่องนั้นสำคัญและเป็นความจริง นอกจากนี้ยัง Framing Theory ที่สื่อกำหนดกรอบการมองโลกของผู้รับสาร',
      7: 'ในยุคสื่อดั้งเดิม ผู้รับสารมีบทบาทเพียง Passive Audience แต่ในยุคดิจิทัล ผู้รับสารกลายเป็น Prosumer ที่ผสมบทบาทผู้ผลิตและผู้บริโภคเข้าด้วยกัน แพลตฟอร์มอย่าง Instagram, TikTok ทำให้ทุกคนเป็นสื่อได้ ส่งผลให้อำนาจการผลิตเนื้อหากระจายตัวจากองค์กรสื่อไปสู่บุคคลทั่วไป',
    }
  },
  {
    id: 5, studentId: '65010002', name: 'นายธีระพล แก้วมณี', year: 1, submittedAt: '10:01:22',
    mcScore: 6, essayScores: {}, totalScore: null, maxScore: 30, status: 'รอตรวจ',
    answers: {
      0: 'a', 1: 'c', 2: 'a', 3: 'a', 4: 'c',
      5: 'Two-Step Flow มีผู้นำความคิดเป็นตัวกลาง One-Step Flow ไม่มี',
      6: 'Fake News ส่งผลเสียต่อสังคม',
      7: 'ยุคดิจิทัลมีความแตกต่างจากยุคเก่า',
    }
  },
];
